<template>
  <div>
    <v-chip id="melhor-preco" label small class="primary my-1 caption" v-if="produto.$melhorFrete" >
      {{ produto.frete.tipoFrete }}
      <span v-if="produto.frete.totalTransporte">
        &nbsp;({{ produto.frete.totalTransporteConvertido | currency }})
      </span>
      <br/>
      ({{ prazoEntregaFormatado(produto.frete.prazoEntrega) }})
    </v-chip>
    <div v-else class="my-1 caption">
      {{ produto.frete.tipoFrete }}
      <span v-if="produto.frete.totalTransporte">
        &nbsp;({{ produto.frete.totalTransporteConvertido | currency }})
      </span>
      <br/>
      ({{ prazoEntregaFormatado(produto.frete.prazoEntrega) }})
    </div>
  </div>
</template>

<style>
#melhor-preco {
  height: auto;
}
#melhor-preco .v-chip__content {
  display: block;
}
</style>

<script>
export default {
  props: {
    produto: Object,
  },
  methods: {
    prazoEntregaFormatado(prazo) {
      return prazo === 1 ? '1 dia útil' : `${prazo} dias úteis`;
    },
  },
};
</script>
